import React from 'react';

const About = () => {
    return (
      <div className=" text-lg mt-[100px] border-4 p-5 m-3">
        <h2 className="flex justify-center font-bold font-sans">I'm Fuad, an undergrad student of CSE. I'm a passionate programmer. I did learn C/Cpp, Java, Python, Assembly x86, MySQL, HTML, CSS, JS, Bootstrap, Tailwind CSS React JS, etc.
Interests: working with GUI (Learned Swing), Developing web applications(started learning).
Also learned: Unity (wished to be a game developer someday so I did learn a bit).
I also learned touch-typing when I was on cls 10 (wpm: 55+).</h2>
        
      </div>
    );
};

export default About;